<template>
  <div id="home">
    <top :topIndex="0"></top>
    <div class="mian" :style="{ height: mianH + 'px' }">
      <left :leftIndex="0"></left>
      <homeMain></homeMain>
    </div>
    <RightDisplayArea></RightDisplayArea>
    <Welcome ref="welcome"></Welcome>
  </div>
</template>

<script>
import InApi from '@/api/invite'
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import homeMain from '@/components/home_mian.vue' //右侧主体部分
import RightDisplayArea from '@/components/dongeb/RightDisplayArea.vue'
import Welcome from '@/components/dongeb/welcome.vue'
export default {
  components: {
    top, left, homeMain, RightDisplayArea, Welcome
  },
  data() {
    return {
      mianH: 0,//主题区域宽度
    }
  },
  mounted() {
    let showWelcomeImg = localStorage.getItem(this.welcome)
    if (!showWelcomeImg) {
      this.$refs.welcome.openPrompt()
    }
    let { inviteCode } = this.$route.query
    if (inviteCode) {
      InApi.inviteCodeBind({ code: inviteCode }).then(res => {
        if (res.code === 200) {
          this.$message.success('绑定邀请码操作成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    }

    this.calculateMianHeight();
    window.addEventListener('resize', this.calculateMianHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateMianHeight);
  },
  methods: {
    calculateMianHeight() {
      this.mianH = window.innerHeight - 63;
    }
  }
}
</script>

<style scoped>
.mian {
  display: flex;
}
</style>